export const trimestres = [
    {
        id: 1,
        nombre: 'Primer Trimestre'
    },
    {
        id: 2,
        nombre: 'Segundo Trimestre'
    },
    {
        id: 3,
        nombre: 'Tercer Trimestre'
    },
    {
        id: 4,
        nombre: 'Cuarto Trimestre'
    },
]